import { Box, Typography } from '@mui/material'
import { RequesterFormDisclaimerProps } from './_props'
import AnnouncementIcon from '@mui/icons-material/Announcement'
import sxs from './_sxs'

const RequesterFormDisclaimer = ({ title, contents, displayed }: RequesterFormDisclaimerProps) => {
    if (!displayed) return null

    return (
        <Box sx={sxs.requesterFormDisclaimer}>
            <Box sx={sxs.requesterFormDisclaimerLeft}>
                <AnnouncementIcon sx={sxs.requesterFormDisclaimerIcon} />
            </Box>
            <Box>
                <Typography sx={sxs.requesterFormDisclaimerTitle}>{title || 'Informations manquantes'}</Typography>
                <Box sx={sxs.requesterFormDisclaimerContents}>
                    {contents.map((content) => (
                        <Typography key={content.id} sx={sxs.requesterFormDisclaimerContent}>
                            {content.text}
                        </Typography>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default RequesterFormDisclaimer
